import { type GTMEvent, pushToDataLayer } from '../../../services/gtmService';

export enum NotificationFrequency {
  DAILY = 'DAILY',
  INSTANT = 'INSTANT',
  OFF = 'OFF',
}

enum Events {
  SEARCH_PAGE = 'search-page',
  CREATE_SAVED_AD = 'create_saved_ad',
  DELETE_SAVED_AD = 'delete_saved_ad',
  CREATE_SAVED_SEARCH = 'create_saved_search',
}

const GTM_Alert_Types = {
  DAILY: 'daily_alerts',
  INSTANT: 'instant_alerts',
  OFF: 'no_alerts',
};

const useDealerPageGTM = (gtmData: GTMEvent) => {
  const pushData = (event: string, customData?: GTMEvent) => {
    if (customData) {
      pushToDataLayer({ ...gtmData, ...customData, event });
    } else {
      pushToDataLayer({ ...gtmData, event });
    }
  };

  const searchPageEvent = (data?: GTMEvent) => {
    pushData(Events.SEARCH_PAGE, data);
  };

  const createSavedAdEvent = (adId: number, data?: GTMEvent) => {
    pushData(Events.CREATE_SAVED_AD, { savedAdId: [adId], ...data });
  };

  const deleteSavedAdEvent = (data?: GTMEvent) => {
    pushData(Events.DELETE_SAVED_AD, data);
  };

  const createSavedSearchEvent = (
    alertType: keyof typeof NotificationFrequency,
    data?: GTMEvent,
  ) => {
    pushData(Events.CREATE_SAVED_SEARCH, {
      alertType: [GTM_Alert_Types[alertType]],
      ...data,
    });
  };

  return {
    searchPageEvent,
    createSavedAdEvent,
    deleteSavedAdEvent,
    createSavedSearchEvent,
  };
};

export { useDealerPageGTM };
